import { Box, Grid, Collapse, Card } from "@mui/material";

import ActiveFilters from "../../../Components/filters/ActiveFilters";

import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  // All filters in the order they appear
  const activeFilterDefinitions = [
    // Standard filters - in order
    {
      type: "standard",
      id: "freightCode",
      label: "Freight Code",
      value: submittedData.freightCode,
    },
  ];

  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;